import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from "dayjs";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

import Pagination from "../../../pages/Pagination";
import { useAccess, FEATURES } from "../../../hooks/useAccess";
import {
  getBaishunGames,
  getBaishunHistory,
} from "../../../store/BaishunHistory/action";

const formatNumber = (value) => Number(value || 0).toLocaleString();

const BaishunHistory = (props) => {
  const { games, history, stats, pagination } = useSelector(
    (state) => state.baishunHistory,
  );
  const { canView } = useAccess();

  const [selectedGameId, setSelectedGameId] = useState("ALL");
  const [date, setDate] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const [startDate, setStartDate] = useState("ALL");
  const [endDate, setEndDate] = useState("ALL");
  const [activePage, setActivePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const gameNames = useMemo(
    () =>
      games.reduce((names, game) => {
        names[String(game.gameId)] = game.name;
        return names;
      }, {}),
    [games],
  );

  const loadHistory = () => {
    props.getBaishunHistory({
      page: activePage,
      limit: rowsPerPage,
      gameId: selectedGameId,
      startDate,
      endDate,
    });
  };

  useEffect(() => {
    props.getBaishunGames();
  }, []);

  useEffect(() => {
    loadHistory();
  }, [activePage, rowsPerPage, selectedGameId, startDate, endDate]);

  const clearFilters = () => {
    setActivePage(1);
    setSelectedGameId("ALL");
    setStartDate("ALL");
    setEndDate("ALL");
    setDate([
      {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
    ]);
    $("#baishunDatePicker").removeClass("show");
  };

  const handleRowsPerPage = (value) => {
    setActivePage(1);
    setRowsPerPage(value);
  };

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-white">BAISHUN Games History</h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav
              aria-label="breadcrumb"
              className="breadcrumb-header float-start float-lg-end"
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  BAISHUN Games History
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="row">
        {canView(FEATURES.GAME_BAISHUN_SUMMARY_TOTAL_GAMES) && (
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="card stats-card">
              <div className="card-body">
                <div className="stats-info">
                  <h5 className="card-title">{formatNumber(stats.totalGames)}</h5>
                  <p className="stats-text">Total Games</p>
                </div>
                <div className="stats-icon">
                  <i className="material-icons">videogame_asset</i>
                </div>
              </div>
            </div>
          </div>
        )}
        {canView(FEATURES.GAME_BAISHUN_SUMMARY_DIAMOND_SPENT) && (
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="card stats-card">
              <div className="card-body">
                <div className="stats-info">
                  <h5 className="card-title">
                    {formatNumber(stats.totalDiamondsSpent)}
                  </h5>
                  <p className="stats-text">Total Diamonds Spent</p>
                </div>
                <div className="stats-icon">
                  <i className="material-icons">monetization_on</i>
                </div>
              </div>
            </div>
          </div>
        )}
        {canView(FEATURES.GAME_BAISHUN_SUMMARY_DIAMONDS_WON) && (
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="card stats-card">
              <div className="card-body">
                <div className="stats-info">
                  <h5 className="card-title">
                    {formatNumber(stats.totalDiamondsWon)}
                  </h5>
                  <p className="stats-text">Total Diamonds Won</p>
                </div>
                <div className="stats-icon">
                  <i className="material-icons">stars</i>
                </div>
              </div>
            </div>
          </div>
        )}
        {canView(FEATURES.GAME_BAISHUN_SUMMARY_HOUSE_PROFIT) && (
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="card stats-card">
              <div className="card-body">
                <div className="stats-info">
                  <h5 className="card-title">{formatNumber(stats.houseProfit)}</h5>
                  <p className="stats-text">House Profit (Diamonds)</p>
                </div>
                <div className="stats-icon">
                  <i className="material-icons">trending_up</i>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="row">
        <div className="col">
          <div className="card" id="card">
            <div className="card-header pb-0">
              <div className="row my-3 align-items-center">
                <div className="col-lg-8">
                  <div className="d-flex flex-wrap align-items-center">
                    <button
                      className="btn btn-info"
                      style={{ marginRight: 5 }}
                      onClick={clearFilters}
                    >
                      All
                    </button>
                    <button
                      className="btn btn-success"
                      style={{ marginRight: 5 }}
                      onClick={loadHistory}
                    >
                      <i className="fas fa-sync-alt"></i> Refresh
                    </button>
                    <button
                      className="collapsed btn btn-info"
                      style={{ marginRight: 10 }}
                      data-toggle="collapse"
                      data-target="#baishunDatePicker"
                      onClick={() =>
                        $("#baishunDatePicker").toggleClass("collapse")
                      }
                    >
                      Analytics
                      <ExpandMoreIcon />
                    </button>
                    <select
                      className="form-select"
                      aria-label="Filter BAISHUN history by game"
                      style={{ width: 230 }}
                      value={selectedGameId}
                      onChange={(event) => {
                        setActivePage(1);
                        setSelectedGameId(event.target.value);
                      }}
                    >
                      <option value="ALL">All BAISHUN Games</option>
                      {games.map((game) => (
                        <option key={game.gameId} value={game.gameId}>
                          {game.name}
                        </option>
                      ))}
                    </select>
                    {startDate !== "ALL" && (
                      <p style={{ paddingLeft: 10 }} className="my-2">
                        {startDate} to {endDate}
                      </p>
                    )}
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="d-flex justify-content-end mt-3 mt-lg-0">
                    <span className="text-danger">
                      Total Records:
                      <span className="text-info">
                        &nbsp;&nbsp;{formatNumber(pagination.totalRecords)}
                      </span>
                    </span>
                  </div>
                </div>
                <div
                  id="baishunDatePicker"
                  className="collapse mt-5 pt-5"
                  aria-expanded="false"
                >
                  <div className="container table-responsive">
                    <DateRangePicker
                      onChange={(item) => {
                        setDate([item.selection]);
                        setActivePage(1);
                        setStartDate(
                          dayjs(item.selection.startDate).format("YYYY-MM-DD"),
                        );
                        setEndDate(
                          dayjs(item.selection.endDate).format("YYYY-MM-DD"),
                        );
                      }}
                      showSelectionPreview={true}
                      moveRangeOnFirstSelection={false}
                      ranges={date}
                      direction="horizontal"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="card-body card-overflow">
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Game</th>
                      <th>User</th>
                      <th>User ID</th>
                      <th>Diamond Spent</th>
                      <th>Diamonds Won</th>
                      <th>Result</th>
                      <th>Balance After</th>
                      <th>Round ID</th>
                      <th>Room ID</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {history.length > 0 ? (
                      history.map((record, index) => {
                        const result =
                          record.netResult > 0
                            ? "WIN"
                            : record.netResult < 0
                              ? "LOSE"
                              : "DRAW";
                        const resultClass =
                          result === "WIN"
                            ? "text-success"
                            : result === "LOSE"
                              ? "text-danger"
                              : "text-warning";

                        return (
                          <tr key={`${record.gameId}-${record.roundId}-${index}`}>
                            <td>
                              {(activePage - 1) * rowsPerPage + index + 1}
                            </td>
                            <td className="text-info">
                              {gameNames[String(record.gameId)] ||
                                `Game ${record.gameId}`}
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                {record.user?.image && (
                                  <img
                                    src={record.user.image}
                                    alt={record.user.name || "User"}
                                    style={{
                                      width: 30,
                                      height: 30,
                                      borderRadius: "50%",
                                      objectFit: "cover",
                                      marginRight: 8,
                                    }}
                                  />
                                )}
                                {record.user?.name ||
                                  record.user?.username ||
                                  "Deleted User"}
                              </div>
                            </td>
                            <td className="text-info">
                              {record.user?.uniqueId || "-"}
                            </td>
                            <td className="text-danger">
                              {formatNumber(record.diamondSpent)}
                            </td>
                            <td className="text-success">
                              {formatNumber(record.diamondWon)}
                            </td>
                            <td>
                              <span className={`${resultClass} fw-bold`}>
                                {result}
                              </span>
                            </td>
                            <td className="text-warning">
                              {formatNumber(record.balanceAfter)}
                            </td>
                            <td className="text-primary">{record.roundId}</td>
                            <td>{record.roomId || "-"}</td>
                            <td>
                              <div className="text-info">
                                {dayjs(record.createdAt).format("YYYY-MM-DD")}
                              </div>
                              <div
                                className="text-muted"
                                style={{ fontSize: "0.85em" }}
                              >
                                {dayjs(record.createdAt).format("HH:mm:ss")}
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="11" align="center">
                          Nothing to show!!
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <Pagination
                activePage={activePage}
                rowsPerPage={rowsPerPage}
                userTotal={pagination.totalRecords || 0}
                handleRowsPerPage={handleRowsPerPage}
                handlePageChange={setActivePage}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, {
  getBaishunGames,
  getBaishunHistory,
})(BaishunHistory);
